import { render, staticRenderFns } from "./ReportarPartida.vue?vue&type=template&id=30406aec&scoped=true&"
import script from "./ReportarPartida.vue?vue&type=script&lang=js&"
export * from "./ReportarPartida.vue?vue&type=script&lang=js&"
import style0 from "./ReportarPartida.vue?vue&type=style&index=0&id=30406aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30406aec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VForm,VIcon,VImg,VRow})
